import "./style.scss";
import $ from "jquery";

$(function () {
    $('.menu-side__item--has-children > .menu-side__item-link').on("click", function () {
        console.log("click");
        if ($(this).parent().hasClass("active")) {
            console.log($(this).parent().parent().find(".menu-side__item--has-children"));
            $(this).parent().parent().find(".menu-side__item--has-children").removeClass("active");
        } else {
            $(this).parent().parent().find(".menu-side__item--has-children").removeClass("active");
            $(this).parent().addClass("active");
        }
    });
});